import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface CategoryFeeSummaryRow {
  category: string;
  contractRange: string;
  registrationFee: number;
  vendors: number;
  revenue: number;
}

@Component({
  selector: 'app-category-fee-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './category-fee-summary.component.html',
  styleUrl: './category-fee-summary.component.scss',
})
export class CategoryFeeSummaryComponent {
  @Input({ required: true }) rows: CategoryFeeSummaryRow[] = [];
  @Input() title = 'Category Fee Summary';

  formatCurrency(value: number): string {
    if (!Number.isFinite(value)) return '₦0';
    return `₦${value.toLocaleString('en-NG')}`;
  }
}

